export const formatValue = (value) => (value != null ? value : '-')
